import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import { FOTAStatus } from '../../_interface/updevice-int';
import { NebulaPlugin } from './nebula-plugin';
export var NebulaUpdevicePlugin = function (_NebulaPlugin) {
    _inherits(NebulaUpdevicePlugin, _NebulaPlugin);

    function NebulaUpdevicePlugin() {
        _classCallCheck(this, NebulaUpdevicePlugin);

        var _this = _possibleConstructorReturn(this, (NebulaUpdevicePlugin.__proto__ || Object.getPrototypeOf(NebulaUpdevicePlugin)).call(this));

        _this.onBleHistoryDataListeners = new Map();
        _this.handleClick = _this.handleClick.bind(_this);
        _this.handleSimplifyChanged = _this.handleSimplifyChanged.bind(_this);
        return _this;
    }

    _createClass(NebulaUpdevicePlugin, [{
        key: 'getDeviceBindInfo',
        value: function getDeviceBindInfo(deviceId, callback) {
            window.AlipayJSBridge.call('getDeviceBindInfo', {
                deviceId: deviceId
            }, this.generateCallbackFunc(callback));
        }
    }, {
        key: 'getDeviceInfoById',
        value: function getDeviceInfoById(deviceId, callback) {
            window.AlipayJSBridge.call('getDeviceInfoById', {
                deviceId: deviceId
            }, this.generateCallbackFunc(callback, this.convertUpDeviceModelFrom));
        }
    }, {
        key: 'getDeviceList',
        value: function getDeviceList(familyId, callback) {
            window.AlipayJSBridge.call('getNewDeviceList', {
                familyId: familyId === '' ? null : familyId
            }, this.generateCallbackFunc(callback, this.convertDeviceListFrom));
        }
    }, {
        key: 'getSubDevInfoById',
        value: function getSubDevInfoById(deviceId, subDevId, callback) {
            window.AlipayJSBridge.call('getSubDevInfoById', {
                deviceId: deviceId,
                subDevId: subDevId
            }, this.generateCallbackFunc(callback, this.convertUpDeviceModelFrom));
        }
    }, {
        key: 'getSubDevList',
        value: function getSubDevList(deviceId, callback) {
            window.AlipayJSBridge.call('getNewSubDevList', {
                deviceId: deviceId
            }, this.generateCallbackFunc(callback, this.convertDeviceListFrom));
        }
    }, {
        key: 'getSubDevListBySubDevId',
        value: function getSubDevListBySubDevId(deviceId, callback) {
            window.AlipayJSBridge.call('getSubDevListBySubDevId', {
                deviceId: deviceId
            }, this.generateCallbackFunc(callback, this.convertUpdeviceBaseInfoFrom));
        }
    }, {
        key: 'updateDeviceList',
        value: function updateDeviceList(immediate, callback) {
            window.AlipayJSBridge.call('updateDeviceList', {
                immediate: immediate
            }, this.generateCallbackFunc(callback));
        }
    }, {
        key: 'isBound',
        value: function isBound(deviceId, callback) {
            window.AlipayJSBridge.call('isBound', {
                deviceId: deviceId
            }, this.generateCallbackFunc(callback));
        }
    }, {
        key: 'subscribeDeviceChange',
        value: function subscribeDeviceChange(deviceId, listeners, callback) {
            var _this2 = this;

            var self = this;
            document.container.addEventListener('publishNewDeviceChange', function (result) {
                var mac = result === null || result === void 0 ? void 0 : result.mac;
                var retDevInfo = result === null || result === void 0 ? void 0 : result.retDevInfo;
                listeners.deviceInfoListener(mac, _this2.createDeviceModelFrom(retDevInfo));
            });
            document.container.addEventListener('publishNewSubDevChange', function (result) {
                var mac = result === null || result === void 0 ? void 0 : result.mac;
                var retDevInfo = result === null || result === void 0 ? void 0 : result.retDevInfo;
                listeners.subDeviceInfoListener(mac, _this2.createDeviceModelFrom(retDevInfo));
            });
            document.container.addEventListener('publishNewDeviceAlarm', function (result) {
                var mac = result === null || result === void 0 ? void 0 : result.mac;
                var alarmList = result === null || result === void 0 ? void 0 : result.alarmList;
                var list = new Array();
                alarmList.map(function (alarm) {
                    list.push(self.createDeviceAlarmFrom(alarm));
                });
                listeners.deviceAlarmListener(mac, list);
            });
            document.container.addEventListener('publishNewSubDevAlarm', function (result) {
                var mac = result === null || result === void 0 ? void 0 : result.mac;
                var alarmList = result === null || result === void 0 ? void 0 : result.alarmList;
                var list = new Array();
                alarmList.map(function (alarm) {
                    list.push(self.createDeviceAlarmFrom(alarm));
                });
                listeners.subDeviceAlarmListener(mac, list);
            });
            document.container.addEventListener('publishNewSubDevListChange', function (result) {
                var mac = result === null || result === void 0 ? void 0 : result.mac;
                var deviceList = result === null || result === void 0 ? void 0 : result.deviceList;
                var list = [];
                deviceList.map(function (device) {
                    list.push(self.createDeviceModelFrom(device));
                });
                listeners.subDeviceListListener(mac, list);
            });
            document.container.addEventListener('publishBleRealTimeDataChange', function (result) {
                var mac = result === null || result === void 0 ? void 0 : result.mac;
                var resoureData = result === null || result === void 0 ? void 0 : result.encode;
                listeners.bleRealTimeDataListener(mac, resoureData);
            });
            window.AlipayJSBridge.call('subscribeNewDeviceChange', {
                deviceId: deviceId
            }, this.generateCallbackFunc(callback));
        }
    }, {
        key: 'initListeners',
        value: function initListeners(deviceId, callback) {
            window.AlipayJSBridge.call('subscribeNewDeviceChange', {
                deviceId: deviceId
            }, this.generateCallbackFunc(callback));
        }
    }, {
        key: 'subscribeDeviceListChange',
        value: function subscribeDeviceListChange(listener, callback) {
            var self = this;
            document.container.addEventListener('publishNewDeviceListChange', function (result) {
                var deviceList = result === null || result === void 0 ? void 0 : result.deviceList;
                var list = [];
                deviceList.map(function (device) {
                    list.push(self.createDeviceModelFrom(device));
                });
                listener(list);
            });
            window.AlipayJSBridge.call('subscribeNewDeviceListChange', null, this.generateCallbackFunc(callback));
        }
    }, {
        key: 'executeOperation',
        value: function executeOperation(deviceId, subDevId, groupName, command, callback) {
            var commandObj = {};
            command.forEach(function (cmd) {
                commandObj[cmd.name] = cmd.value;
            });
            window.AlipayJSBridge.call('executeOperation', {
                deviceId: deviceId,
                subDevId: subDevId,
                groupName: groupName,
                command: commandObj
            }, this.generateCallbackFunc(callback));
        }
    }, {
        key: 'subscribeBleHistoryDataReport',
        value: function subscribeBleHistoryDataReport(deviceId, listener, callback) {
            var bleHistorylistener = function bleHistorylistener(result) {
                var mac = result === null || result === void 0 ? void 0 : result.mac;
                var bleHistoryInfo = result === null || result === void 0 ? void 0 : result.bleHistoryInfo;
                listener(mac, JSON.stringify(bleHistoryInfo));
            };
            this.onBleHistoryDataListeners.set(deviceId, bleHistorylistener);
            document.container.addEventListener('publishBleHistoryDataChange', bleHistorylistener);
            window.AlipayJSBridge.call('fetchBleHistoryData', {
                deviceId: deviceId
            }, this.generateCallbackFunc(callback));
        }
    }, {
        key: 'unsubscribeBleHistoryDataReport',
        value: function unsubscribeBleHistoryDataReport(deviceId, callback) {
            var bleHistorylistener = this.onBleHistoryDataListeners.get(deviceId);
            if (bleHistorylistener) {
                document.container.removeEventListener('publishBleHistoryDataChange', bleHistorylistener);
            }
            window.AlipayJSBridge.call('cancelFetchBleHistoryData', {
                deviceId: deviceId
            }, this.generateCallbackFunc(callback));
        }
    }, {
        key: 'subscribeResource',
        value: function subscribeResource(_deviceId, _resName, _listener, _callback) {
            document.container.addEventListener('onUplusReportDeviceReceive', function (result) {
                var mac = result === null || result === void 0 ? void 0 : result.mac;
                var name = result === null || result === void 0 ? void 0 : result.name;
                var encode = result === null || result === void 0 ? void 0 : result.encode;
                _listener(mac, name, encode);
            });
            window.AlipayJSBridge.call('subscribeResource', {
                deviceId: _deviceId,
                resName: _resName
            }, this.generateCallbackFunc(_callback));
        }
    }, {
        key: 'unsubscribeResource',
        value: function unsubscribeResource(_deviceId, _resName, _callback) {
            window.AlipayJSBridge.call('unsubscribeResource', {
                deviceId: _deviceId,
                resName: _resName
            }, this.generateCallbackFunc(_callback));
        }
    }, {
        key: 'startBoardFota',
        value: function startBoardFota(deviceId, subDevId, listener, callback) {
            document.container.addEventListener('publishBoardFotaStatus', function (result) {
                var _a, _b;
                var mac = result === null || result === void 0 ? void 0 : result.mac;
                var deviceInfo = result === null || result === void 0 ? void 0 : result.deviceInfo;
                var status = new FOTAStatus();
                status.upgradeErrInfo = (_a = deviceInfo === null || deviceInfo === void 0 ? void 0 : deviceInfo.upgradeErrInfo) !== null && _a !== void 0 ? _a : '';
                status.upgradeStatus = (_b = deviceInfo === null || deviceInfo === void 0 ? void 0 : deviceInfo.upgradeStatus) !== null && _b !== void 0 ? _b : 106;
                listener(mac, status);
            });
            window.AlipayJSBridge.call('startBoardFotaWithFotaInfo', {
                deviceId: deviceId,
                subDevId: subDevId
            }, this.generateCallbackFunc(callback));
        }
    }, {
        key: 'subscribeBoardFOTAStatus',
        value: function subscribeBoardFOTAStatus(listener) {
            document.container.addEventListener('publishBoardFotaStatus', function (result) {
                var _a, _b;
                var mac = result === null || result === void 0 ? void 0 : result.mac;
                var deviceInfo = result === null || result === void 0 ? void 0 : result.deviceInfo;
                var status = new FOTAStatus();
                status.upgradeErrInfo = (_a = deviceInfo === null || deviceInfo === void 0 ? void 0 : deviceInfo.upgradeErrInfo) !== null && _a !== void 0 ? _a : '';
                status.upgradeStatus = (_b = deviceInfo === null || deviceInfo === void 0 ? void 0 : deviceInfo.upgradeStatus) !== null && _b !== void 0 ? _b : 106;
                status.deviceId = mac ? mac : '';
                listener(status);
            });
        }
    }, {
        key: 'startBoardFotaWithFotaInfo',
        value: function startBoardFotaWithFotaInfo(deviceId, subDevId, callback) {
            window.AlipayJSBridge.call('startBoardFotaWithFotaInfo', {
                deviceId: deviceId,
                subDevId: subDevId
            }, this.generateCallbackFunc(callback));
        }
    }, {
        key: 'checkBoardFotaInfo',
        value: function checkBoardFotaInfo(deviceId, subDevId, callback) {
            window.AlipayJSBridge.call('checkBoardFotaInfo', {
                deviceId: deviceId,
                subDevId: subDevId
            }, this.generateCallbackFunc(callback, this.convertFotaInfoForm));
        }
    }, {
        key: 'fetchBoardFotaStatus',
        value: function fetchBoardFotaStatus(deviceId, subDevId, callback) {
            window.AlipayJSBridge.call('fetchBoardFotaStatus', {
                deviceId: deviceId,
                subDevId: subDevId
            }, this.generateCallbackFunc(callback, this.convertFotaStatusForm));
        }
    }, {
        key: 'inFocus',
        value: function inFocus(deviceId, callback) {
            window.AlipayJSBridge.call('inFocus', {
                deviceId: deviceId
            }, this.generateCallbackFunc(callback));
        }
    }, {
        key: 'outFocus',
        value: function outFocus(deviceId, callback) {
            window.AlipayJSBridge.call('outFocus', {
                deviceId: deviceId
            }, this.generateCallbackFunc(callback));
        }
    }, {
        key: 'handleClick',
        value: function handleClick(result) {
            var _this3 = this;

            var retDevInfo = result === null || result === void 0 ? void 0 : result.retDevInfo;
            var list = [];
            document.container.upLogModule.printLog({ level: 'info', tag: 'uplusapi', msg: 'handleClickReportBatchData: ' + JSON.stringify(retDevInfo) });
            retDevInfo.map(function (deviceInfo) {
                list.push(_this3.createDeviceInfoModelFrom(deviceInfo));
            });
            this.eventListener(list);
        }
    }, {
        key: 'handleSimplifyChanged',
        value: function handleSimplifyChanged(result) {
            var _this4 = this;

            var retDevInfo = result === null || result === void 0 ? void 0 : result.retDevInfo;
            var list = [];
            document.container.upLogModule.printLog({ level: 'info', tag: 'uplusapi', msg: 'handleSimplifyChanged: ' + JSON.stringify(retDevInfo) });
            retDevInfo.map(function (deviceInfo) {
                list.push(_this4.createSimplifyModelFrom(deviceInfo));
            });
            this.eventSimplifyListener(list);
        }
        // 批量订阅

    }, {
        key: 'batchSubscribeNewDeviceChange',
        value: function batchSubscribeNewDeviceChange(familyId, listener, callback) {
            this.eventListener = listener;
            document.container.addEventListener('publishAttrAndCautionDeviceChange', this.handleClick);
            window.AlipayJSBridge.call('batchSubscribeNewDeviceChange', { familyId: familyId }, this.generateCallbackFunc(callback));
        }
        // 批量取消订阅

    }, {
        key: 'batchUnsubscribeNewDeviceChange',
        value: function batchUnsubscribeNewDeviceChange(callback) {
            window.AlipayJSBridge.call('batchUnsubscribeNewDeviceChange', null, this.generateCallbackFunc(callback));
        }
    }, {
        key: 'getDeviceModelMixLogicAttrsListBy',
        value: function getDeviceModelMixLogicAttrsListBy(familyId, callback) {
            window.AlipayJSBridge.call('getNewDeviceList', {
                familyId: familyId === '' ? null : familyId
            }, this.generateCallbackFunc(callback, this.convertDeviceMixLogicAttrsListFrom));
        }
    }, {
        key: 'getDeviceNetworkQuality',
        value: function getDeviceNetworkQuality(deviceId, callback) {
            window.AlipayJSBridge.call('getDeviceNetworkQuality', {
                deviceId: deviceId
            }, this.generateCallbackFunc(callback, this.convertUpDeviceNetWorkQualityModelFrom));
        }
        // 获取当前设备的网络类型

    }, {
        key: 'getNetType',
        value: function getNetType(deviceId, callback) {
            window.AlipayJSBridge.call('getNetType', {
                deviceId: deviceId
            }, this.generateCallbackFunc(callback));
        }
        // 批量订阅

    }, {
        key: 'batchAttachWitchSimplifyData',
        value: function batchAttachWitchSimplifyData(devices, listener, callback) {
            this.eventSimplifyListener = listener;
            document.container.addEventListener('publishSimplifyDeviceChange', this.handleSimplifyChanged);
            window.AlipayJSBridge.call('batchAttachWitchSimplifyData', { devices: devices }, this.generateCallbackFunc(callback, this.convertSimplifyListFrom));
        }
        // 批量取消订阅

    }, {
        key: 'batchDetachWitchDeviceIds',
        value: function batchDetachWitchDeviceIds(deviceIds, callback) {
            window.AlipayJSBridge.call('batchDetachWitchDeviceIds', { deviceIds: deviceIds }, this.generateCallbackFunc(callback));
        }
        // 解码订阅设备资源

    }, {
        key: 'subscribeResourceWithDecode',
        value: function subscribeResourceWithDecode(_deviceId, _resName, _listener, _callback) {
            document.container.addEventListener('onUplusReportDeviceReceive', function (result) {
                var mac = result === null || result === void 0 ? void 0 : result.mac;
                var name = result === null || result === void 0 ? void 0 : result.name;
                var encode = result === null || result === void 0 ? void 0 : result.encode;
                _listener(mac, name, encode);
            });
            window.AlipayJSBridge.call('subscribeResourceWithDecode', {
                deviceId: _deviceId,
                resName: _resName
            }, this.generateCallbackFunc(_callback));
        }
        // 获取可与当前设备分到同一组的设备列表, 当前设备要求有zigbee能力或BLEMesh能力

    }, {
        key: 'fetchGroupableDeviceList',
        value: function fetchGroupableDeviceList(deviceId, callback) {
            window.AlipayJSBridge.call('fetchGroupableDeviceList', {
                deviceId: deviceId
            }, this.generateCallbackFunc(callback));
        }
        // 创建分组

    }, {
        key: 'createDeviceGroup',
        value: function createDeviceGroup(deviceId, callback) {
            window.AlipayJSBridge.call('createDeviceGroup', {
                deviceId: deviceId
            }, this.generateCallbackFunc(callback));
        }
        // 向组设备中添加设备，要求当前device对象为组设备

    }, {
        key: 'addDevicesToGroup',
        value: function addDevicesToGroup(deviceId, deviceIds, callback) {
            window.AlipayJSBridge.call('addDevicesToGroup', {
                deviceId: deviceId,
                deviceIds: deviceIds
            }, this.generateCallbackFunc(callback));
        }
        // 从组设备中移除设备，要求当前device对象为组设备

    }, {
        key: 'removeDevicesFromGroup',
        value: function removeDevicesFromGroup(deviceId, deviceIds, callback) {
            window.AlipayJSBridge.call('removeDevicesFromGroup', {
                deviceId: deviceId,
                deviceIds: deviceIds
            }, this.generateCallbackFunc(callback));
        }
        // 删除组设备，要求当前device对象为组设备

    }, {
        key: 'deleteDeviceGroup',
        value: function deleteDeviceGroup(deviceId, callback) {
            window.AlipayJSBridge.call('deleteDeviceGroup', {
                deviceId: deviceId
            }, this.generateCallbackFunc(callback));
        }
        // 组设备获取当前组内的所有子设备，非组设备返回空集合

    }, {
        key: 'getGroupMemberList',
        value: function getGroupMemberList(deviceId, callback) {
            window.AlipayJSBridge.call('getGroupMemberList', {
                deviceId: deviceId
            }, this.generateCallbackFunc(callback));
        }
        // 是否为组设备

    }, {
        key: 'isGroup',
        value: function isGroup(deviceId, callback) {
            window.AlipayJSBridge.call('isGroup', {
                deviceId: deviceId
            }, this.generateCallbackFunc(callback));
        }
        // 开始设备固件升级指令

    }, {
        key: 'startFOTAWithDeviceFOTA',
        value: function startFOTAWithDeviceFOTA(data, callback) {
            window.AlipayJSBridge.call('startFOTAWithDeviceFOTA', data, this.generateCallbackFunc(callback));
        }
        // 获取云存视频可播放日期信息

    }, {
        key: 'getCloudVideoDateListByTimezone',
        value: function getCloudVideoDateListByTimezone(data, callback) {
            window.AlipayJSBridge.call('getCloudVideoDateListByTimezone', data, this.generateCallbackFunc(callback));
        }
        // 获取云存回放文件列表

    }, {
        key: 'getCloudVideoPlayListByDeviceId',
        value: function getCloudVideoPlayListByDeviceId(data, callback) {
            window.AlipayJSBridge.call('getCloudVideoPlayListByDeviceId', data, this.generateCallbackFunc(callback), this.convertPlayBackItemFrom);
        }
        // 获取云存回放 m3u8 播放地址

    }, {
        key: 'getVideoPlayAddressByDeviceId',
        value: function getVideoPlayAddressByDeviceId(data, callback) {
            window.AlipayJSBridge.call('getVideoPlayAddressByDeviceId', data, this.generateCallbackFunc(callback));
        }
    }, {
        key: 'isSupportOneKeyConnect',
        value: function isSupportOneKeyConnect(deviceId, callback) {
            window.AlipayJSBridge.call('isSupportOneKeyConnect', {
                deviceId: deviceId
            }, this.generateCallbackFunc(callback));
        }
    }, {
        key: 'subscribeOneKeyScanner',
        value: function subscribeOneKeyScanner(deviceId, listener, callback) {
            var _this5 = this;

            document.container.addEventListener('onUplusFindNewDevicesReceive', function (result) {
                var mac = result === null || result === void 0 ? void 0 : result.mac;
                var deviceList = result === null || result === void 0 ? void 0 : result.deviceList;
                listener.findNewDevicesListener(mac, _this5.convertUpDeviceBaseInfoList(deviceList));
            });
            document.container.addEventListener('onUplusUpdateDevicesReceive', function (result) {
                var mac = result === null || result === void 0 ? void 0 : result.mac;
                var deviceList = result === null || result === void 0 ? void 0 : result.deviceList;
                listener.updateDevicesListener(mac, _this5.convertUpDeviceBaseInfoList(deviceList));
            });
            document.container.addEventListener('onUplusRemoveDevicesReceive', function (result) {
                var mac = result === null || result === void 0 ? void 0 : result.mac;
                var deviceList = result === null || result === void 0 ? void 0 : result.deviceList;
                listener.removeDevicesListener(mac, _this5.convertUpDeviceBaseInfoList(deviceList));
            });
            window.AlipayJSBridge.call('subscribeOneKeyScanner', {
                deviceId: deviceId
            }, this.generateCallbackFunc(callback));
        }
    }, {
        key: 'unsubscribeOneKeyScanner',
        value: function unsubscribeOneKeyScanner(deviceId, callback) {
            window.AlipayJSBridge.call('unsubscribeOneKeyScanner', {
                deviceId: deviceId
            }, this.generateCallbackFunc(callback));
        }
    }, {
        key: 'startScanConfigurableDevice',
        value: function startScanConfigurableDevice(deviceId, callback) {
            window.AlipayJSBridge.call('startScanConfigurableDevice', {
                deviceId: deviceId
            }, this.generateCallbackFunc(callback));
        }
    }, {
        key: 'stopScanConfigurableDevice',
        value: function stopScanConfigurableDevice(deviceId, callback) {
            window.AlipayJSBridge.call('stopScanConfigurableDevice', {
                deviceId: deviceId
            }, this.generateCallbackFunc(callback));
        }
    }, {
        key: 'getConfigurableDeviceList',
        value: function getConfigurableDeviceList(deviceId, callback) {
            window.AlipayJSBridge.call('getConfigurableDeviceList', {
                deviceId: deviceId
            }, this.generateCallbackFunc(callback, this.convertUpdeviceBaseInfoFrom));
        }
    }, {
        key: 'bindOneKeyConnectDevice',
        value: function bindOneKeyConnectDevice(deviceId, bindDeviceIds, listener, callback) {
            var _this6 = this;

            document.container.addEventListener('onUplusBindOneKeyConnectDeviceReceive', function (result) {
                var bindDeviceId = result === null || result === void 0 ? void 0 : result.bindDeviceId;
                var bindProgress = result === null || result === void 0 ? void 0 : result.bindProgress;
                listener(bindDeviceId, _this6.createBindProgressFrom(bindProgress));
            });
            window.AlipayJSBridge.call('bindOneKeyConnectDevice', {
                deviceId: deviceId,
                bindDeviceIds: bindDeviceIds
            }, this.generateCallbackFunc(callback));
        }
    }, {
        key: 'connectDevice',
        value: function connectDevice(deviceId, callback) {
            window.AlipayJSBridge.call('connectDevice', {
                deviceId: deviceId
            }, this.generateCallbackFunc(callback));
        }
    }, {
        key: 'disconnectDevice',
        value: function disconnectDevice(deviceId, callback) {
            window.AlipayJSBridge.call('disconnectDevice', {
                deviceId: deviceId
            }, this.generateCallbackFunc(callback));
        }
    }, {
        key: 'wakeUp',
        value: function wakeUp(deviceId, callback) {
            window.AlipayJSBridge.call('wakeUp', {
                deviceId: deviceId
            }, this.generateCallbackFunc(callback));
        }
    }, {
        key: 'getSleepState',
        value: function getSleepState(deviceId, callback) {
            window.AlipayJSBridge.call('getSleepState', {
                deviceId: deviceId
            }, this.generateCallbackFunc(callback));
        }
    }, {
        key: 'qcConnectDevice',
        value: function qcConnectDevice(deviceId, callback) {
            window.AlipayJSBridge.call('qcConnectDevice', {
                deviceId: deviceId
            }, this.generateCallbackFunc(callback));
        }
    }, {
        key: 'qcDisconnectDevice',
        value: function qcDisconnectDevice(deviceId, callback) {
            window.AlipayJSBridge.call('qcDisconnectDevice', {
                deviceId: deviceId
            }, this.generateCallbackFunc(callback));
        }
    }, {
        key: 'addQCConnectDeviceTimeOutListener',
        value: function addQCConnectDeviceTimeOutListener(listener) {
            document.container.addEventListener('onQcConnectDevice', function (result) {
                var timeoutType = (result === null || result === void 0 ? void 0 : result.timeoutType) || '';
                var deviceId = (result === null || result === void 0 ? void 0 : result.deviceId) || '';
                listener(deviceId, timeoutType);
            });
        }
    }, {
        key: 'getAppFuncModelForDevice',
        value: function getAppFuncModelForDevice(deviceId, callback) {
            window.AlipayJSBridge.call('getAppFuncModelForDevice', {
                deviceId: deviceId
            }, this.generateCallbackFunc(callback));
        }
    }]);

    return NebulaUpdevicePlugin;
}(NebulaPlugin);